module.exports = __webpack_public_path__ + "media/images/landing_side_publishers-c80b4204dd317388ed749a8992afd2db.jpg";